import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=551d6bb4"
import script from "./Brief.vue?vue&type=script&lang=js"
export * from "./Brief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports